import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Form from "react-bootstrap/Form";
import { BsFillPlusSquareFill, BsPencilSquare, BsTrash3 } from 'react-icons/bs';
import PromptBotoxMapDelete from './PromptBotoxMapDelete';
import ErrorDialogModal from './ErrorDialogModal';
import styles from '../../stylesheets/VisualTreatmentModal.module.css'
import userPrefContext from '../../../context/userPrefContext';
import AuthContext from '../../../context/authContext';
import CompanyContext from '../../../context/companyContext';

import VisualTreatmentModal2 from './VisualTreatmentModal2';

let DEFAULT_IMAGE = "";
const publicImage = "botox-map-full.png";

function VisualTreatmentPane(props) {
  // console.count("VisualTreatmentPane")
  // console.log("VisualTreatmentPane props", props)
  
  const userPrefCtx = useContext(userPrefContext);
  const authCtx = useContext(AuthContext)
  const companyCtx = useContext(CompanyContext);

  const defaultImageFromDict = userPrefCtx.dictBotoxMapSrcImage?.file_name;
  //console.log(defaultImageFromDict)

  if(defaultImageFromDict === null || defaultImageFromDict === undefined){
    DEFAULT_IMAGE = publicImage;
    //console.log('defaultImageFromDict is null')
  } else {
    // DEFAULT_IMAGE = `${process.env.REACT_APP_SERVER}/api/v1/botox_maps/dict_botox_map_src_image/${defaultImageFromDict}`
    DEFAULT_IMAGE = `${process.env.REACT_APP_SERVER}/api/v1/botox_maps/dict_botox_map_src_image/${defaultImageFromDict}?dict_company_code_id=${companyCtx.company.id}`
  }


  const [show2, setShow2] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState(false);
  const [editData, setEditData] = useState([]);
  const [openDeleteBotoxModal, setOpenDeleteBotoxModal] = useState(false);
  const [inputList, setInputList] = useState([]);

  const handleEditShow = async (setShowFunc) => { 
    //sending the edit when the edit botox button is clicked
    // setColorValueSource('data');

    // If a button is selected for editing, then it will call the api, otherwise it will send an alert to select an image
      if (props.sendSelectedBotoxIds.length === 1) {

      const url = process.env.REACT_APP_SERVER + `/api/v1/botox_maps/` + props.sendSelectedBotoxIds[0];
      const headers = { Authorization: `Bearer ${userPrefCtx.bearerToken}`, auth: authCtx.authMode,};

      try {
        const response = await fetch(url, { headers });
        if (response.status === 200) {
          const data = await response.json();
          setEditData(data[0])
          console.log('edit response in VisualTreatmentModal',data)
          setShowFunc(true); 
        } else {
          console.log("not 200");
          console.log(props.sendBotoxObjects)
          if(props.sendBotoxObjects[0]['BotoxMapJsonImage']?.botox_map_image_data != null){
            //If the BotoxMapImage is null, it would fail to fetch the edit data from above but would instead use json data to load the botox map from the BotoxMapJsonImage object of that image
            setEditData(props.sendBotoxObjects[0]['BotoxMapJsonImage'])
            //console.log('edit response in VisualTreatmentModal',data)
            setShowFunc(true); 
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    else{
      setErrorDialogMessage(props.sendSelectedBotoxIds.length > 1 ? 'A Maximum Of 1 Images Can Be Selected':'Please select the image to edit')
      setShowError(true);
    }
  
  }
  

  const closeDeleteModal = (data) => {
    setOpenDeleteBotoxModal(false)
  }

  const openDeleteModal = (data) => {
    if(props.sendSelectedBotoxIds.length === 1){
      setOpenDeleteBotoxModal(true)
    } else {
        setErrorDialogMessage('A Maximum Of 1 Images Can Be Selected')
    setShowError(true);
    }
  }

  const sendDeletetoParent = (data) => {
    //This is to send the delete response back to the parent modal to trigger the panel
    props.deleteTrigger(data);
  }




  const onRemove = (index) => {
    setInputList(inputList.filter((_, i) => i !== index));
  };

  const Input = ({ onRemove, index }) => {
    const onRmvBtnClick = () => {
      onRemove(index);
    };
    return (
      <div>
        <div className={styles.add_notes_padding}>
          <Form.Control size="lg" type="text" placeholder="Other Info" />
        </div>
        <div className={styles.add_notes_padding}>
          <Button 
              id="remove-notes"
              className={`btn btn-secondary`}
              onClick={() => onRmvBtnClick()}
          >
            Remove
          </Button>
        </div>
        {console.log("input function")}
      </div>
    );
  };



  return (
    <>
      <ErrorDialogModal
        setOpen={showError}
        close={() => setShowError(false)}
        componentName={'Botox Map'}
        customMessage={errorDialogMessage}
      />
      <Button /*className='mx-2'*/ /*variant="secondary"*/
       size="sm"
       className={styles.enlighten_panel_button}
       onClick={() => props.enlightenPanelButtonClicked()}
       >
          Enlighten Panel
      </Button>
      <BsFillPlusSquareFill onClick={() => {
            // setColorValueSource('default');
            //setting the id to null when the new botox button is clicked
            setEditData([null]);
            setShow2(true);
        }} className="icon-pointer"/>

      <BsPencilSquare onClick={() => handleEditShow(setShow2)} className="icon-pointer"/>
      <BsTrash3 
        onClick={openDeleteModal} 
        className="icon-pointer"
      />

      <PromptBotoxMapDelete 
        setOpen={openDeleteBotoxModal} 
        close={closeDeleteModal}
        //sendID={props.sendDictDiagID}
        sendID={props.sendSelectedBotoxIds[0]}
        //getChild={getDeleteFromChild}
        getChild={sendDeletetoParent}
      /> 

      {show2 && 
      
        <VisualTreatmentModal2 
            show={show2} 
            hide={()=>setShow2(false)}
            sendBotoxtoModal={props.sendBotoxtoModal}
            getModal={props.getModal}
            editData={editData}
            sendBotoxTypeID={props.sendBotoxTypeID}
            deleteTrigger={props.deleteTrigger}
            visitTrigger={props.visitTrigger}
        />
      }


      
    </>
  );
}

export default VisualTreatmentPane;